<app-banner></app-banner>
<div id="staff">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <!-- <div class="card shadow-lg"> -->
                <h4 class="card-title text-center">Staff Details</h4>
                <div class="card-body text-justify">
                    <div class="row image " style=" padding-bottom: 20px;">
                        <div class="col-12 text-center mb-4">
                            <a href="/assets/pdf/Teacher Qualification & Designation.pdf" class="staff-doc-btn" download target="_blank">
                                <i class="fa fa-id-card-o" aria-hidden="true"></i> Download Teacher Qualification & Designation
                            </a>
                        </div>
                        <div class="col-6 text-center mx-auto">
                            <img appLazyload src="/assets/img/staff/staff1.JPG" alt="Staff" class="img-fluid rounded">
                        </div>
                        <!-- <div class="col-6 text-center">
                                    <img appLazyload src="/assets/img/staff/staff2.JPG" alt="Staff" class="img-fluid rounded">
                                </div> -->
                    </div>
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th scope="col">S.NO.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Qualification</th>

                                <th scope="col">Designation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of staff; let i = index;">
                                <th scope="row">{{i+1}}</th>
                                <td class="name">{{item.Name}}</td>
                                <td class="qualification">{{item.Qualification}}</td>
                                <td class="designation">{{item.Designation}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <!-- </div> -->

            </div>
        </div>


    </div>
</div>